import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import _ from "lodash";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { updateEvent } from "DashboardActions";
import { COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";

class GoogleAnalyticSetting extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  onFormSubmit(values) {
    var data = { web_ga: values.web_ga, app_ga: values.app_ga };

    this.setState({ loading: true });
    this.props.updateEvent(this.props.session, data, (response) => {
      this.setState({ loading: false });
      if (response.success) {
        this.props.showSuccess(
          LocaleStrings.analytics_google_setting_form_success
        );
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  }

  render() {
    var { handleSubmit, invalid, pristine, submitting, initialValues } =
      this.props;

    return (
      <div className="appstore-container">
        <Row>
          <Col md={10}>
            <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
              <Field
                name="web_ga"
                label={LocaleStrings.analytics_google_setting_form_label_web_ga}
                placeholder={
                  LocaleStrings.analytics_google_setting_form_ph_web_ga
                }
                type="text"
                mandatory="true"
                labelposition={LABEL_POSITION_TOP}
                component={this.renderFieldText}
              />
              <Field
                name="app_ga"
                label={LocaleStrings.analytics_google_setting_form_label_app_ga}
                placeholder={
                  LocaleStrings.analytics_google_setting_form_ph_app_ga
                }
                type="text"
                mandatory="true"
                labelposition={LABEL_POSITION_TOP}
                component={this.renderFieldText}
              />
              <div className="clearfix">&nbsp;</div>
              <Button
                className="btn-primary settings-save-button"
                loading={this.state.loading}
                type="submit"
                disabled={pristine || invalid || submitting}
              >
                {LocaleStrings.button_save}
              </Button>
            </form>
          </Col>
        </Row>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};
  var web_ga = values["web_ga"];
  var app_ga = values["app_ga"];

  if (!web_ga || web_ga.trim() === "") {
    errors["web_ga"] =
      LocaleStrings.analytics_google_setting_form_validation_required;
  }

  if (!app_ga || app_ga.trim() === "") {
    errors["app_ga"] =
      LocaleStrings.analytics_google_setting_form_validation_required;
  }

  return errors;
}

function mapStateToProps(state) {
  var initVals = null;
  if (state.userEventDetails) {
    initVals = {
      web_ga: state.userEventDetails.web_ga,
      app_ga: state.userEventDetails.app_ga,
    };
  }

  return {
    session: state.session,
    initialValues: initVals,
    userEventDetails: state.userEventDetails,
  };
}

export default connect(mapStateToProps, {
  updateEvent,
  showError,
  showSuccess,
})(
  reduxForm({
    form: "GoogleAnalyticsSettingForm",
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(GoogleAnalyticSetting)
);
